module.exports = __webpack_public_path__ + "img/lux.9b8e2b75.png";